<template lang="pug">
  v-container(fluid)
    Search(:contacts="contacts" :title="title" :loading="loading")
</template>

<script>
import contactService from '../service.js'
import Search from '../components/SearchList'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      contacts: [],
      title: null,
      loading: true
    }
  },
  components: {
    Search
  },
  computed: {
    ...mapGetters('global', ['search'])
  },
  watch: {
    search(val) {
      this.searchInContact(val)
    }
  },
  created() {
    // if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.searchInContact(this.search)
  },
  methods: {
    searchInContact(val) {
      console.log('created search', val)
      // if (!this.$route.params) return this.$router.push("/location")
      this.title = this.search
      this.loading = true
      contactService.searchInContact({search: val})
      .then(result => {
        console.log('contacts', result)
        this.contacts = result.data
        this.loading = false
        console.log('saqib contact', contacts)
      })
    }
   
  }
}
</script>

<style scoped>
</style>